import * as Sentry from '@sentry/react';
// utils
import filterSentryEvent from './utils/filterSentryEvent';

const defaultDsn =
  'https://25e6ce100b0a8c7fdfa693cbf0056f88@o4511987439435776.ingest.de.sentry.io/4511987484065872';
const runtimeEnvironment = (
  process.env.REACT_APP_ENVIRONMENT ||
  process.env.REACT_APP_SENTRY_ENVIRONMENT ||
  process.env.NODE_ENV ||
  'development'
)
  .trim()
  .toLowerCase();

// CRA always sets NODE_ENV=production for optimized builds. An explicit
// REACT_APP_ENVIRONMENT=staging keeps logs available in a staging build.
if (runtimeEnvironment === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
}

Sentry.init({
  // The environment variable makes moving the client to its own Sentry
  // project a configuration-only change later.
  dsn: process.env.REACT_APP_SENTRY_DSN || defaultDsn,
  environment: runtimeEnvironment,
  enabled:
    process.env.NODE_ENV === 'production' ||
    process.env.REACT_APP_SENTRY_ENABLED === 'true',

  // Performance tracing is intentionally not enabled. This project currently
  // only needs real browser exceptions, not successful-request performance
  // issues mixed into the issue list.
  sendDefaultPii: false,
  beforeSend: filterSentryEvent
});
